const amex = '/images/paymentPartners/amex.svg';
const visa = '/images/paymentPartners/visa.svg';
const maestro = '/images/paymentPartners/maestro.svg';
const gpay = '/images/paymentPartners/gpay.svg';
const paytm = '/images/paymentPartners/paytm.svg';
const paypal = '/images/paymentPartners/paypal.svg';
const upi = '/images/paymentPartners/upi.svg';


export const availableOnlinePaymentMethods = [paypal, maestro, amex, visa, gpay, paytm, upi];

export const getCustomModes = (shop, modes) =>
  shop?.paymentModes?.custompayment?.configured
    ?.filter(mode => modes?.find(eachMode => eachMode?.id === mode?._id))

export const getCustomModeName = (mode, customModes) =>
  customModes?.find(eachMode => eachMode?._id === mode?.id)?.mode
